/**
 * En este archivo se definen las distintas instancias de axios necesarias para el aplicativo.
 * Se debe genera una instancia por baseURL que tengamos en nuestro proyecto, por baseURL entendemos el contexto raíz.
 * Por ejemplo:
 * /jwt/xxx
 * /accesosigno/xxx
 * /bdcorporativa
 *
 * Cada uno de estas baseURL requiere su propia instancia de axios. Las instancias pueden ser securizadas con JWT o sin Securizar.
 * Dentro
 *
 */

import { type DefaultGetToken, getJWTInstance, getSimpleInstance } from '@ctn/axios-util';
const BASE_URL = process.env.REACT_APP_BASE_URL ?? '';

// Ejemplo de instancia axios sin securizar, con baseURL ''
const noTokenInstance = getSimpleInstance({ baseURL: BASE_URL });
// Mi obtención del token requiere campos adicionales y es por post
const tokenPostConfiguration: DefaultGetToken = {
	tokenMethod: 'post',
	tokenBaseURL: '/jwt',
	tokenKey: 'PubKey5',
	tokenEndpoint: '/token',
	extraProps: { app: 'miId' },
};
const securedPostTokenInstance = getJWTInstance({
	baseURL: '/secured',
	sessionStorageJWT: 'storage-jwt',
	token: tokenPostConfiguration,
});
// Obtención del token por get sin extraParams
const tokenGetConfiguration: DefaultGetToken = {
	tokenMethod: 'get',
	tokenBaseURL: '/jwt',
	tokenKey: 'PubKey4',
	tokenEndpoint: '/token',
};
const securedGetTokenInstance = getJWTInstance({
	baseURL: '/secured2',
	sessionStorageJWT: 'storage2-jwt',
	token: tokenGetConfiguration,
});

export { noTokenInstance, securedGetTokenInstance, securedPostTokenInstance };
